export default "__VITE_ASSET__CBBOpqTY__"